import { HttpClient } from '@angular/common/http';
import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmployeeAccess } from '@app/ATS/models/employee-access';
import { UserDataServiceInterface } from '@discoverer/attachments/services/user-data-service-interface.service';
import { DynFormComponent } from '@discoverer/dynamic-forms/dyn-forms/dyn-form/dyn-form.component';
import { FormsDataServiceInterface, HttpFormsDataService } from '@discoverer/dynamic-forms/dyn-forms/services';
import { OptionDataServiceInterface, OptionListDataServiceInterface } from '@discoverer/dynamic-forms/option-lists/shared-services/data-service';
import { HasuraOptionListService } from '@discoverer/dynamic-forms/option-lists/shared-services/hasura-option-list-service';
import { HasuraOptionService } from '@discoverer/dynamic-forms/option-lists/shared-services/hasura-option-service';
import { UserDataService } from '@discoverer/app-core';
import { EsearchSettingsService } from '@discoverer/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'new-access-dialog',
    templateUrl: './new-access-dialog.html',
    styleUrls: ['./new-access-dialog.scss'],
    providers: [
        { provide: FormsDataServiceInterface, useClass: HttpFormsDataService, deps: [HttpClient] },
        { provide: OptionListDataServiceInterface, useClass: HasuraOptionListService },
        { provide: OptionDataServiceInterface, useClass: HasuraOptionService },
        { provide: UserDataServiceInterface, useExisting: UserDataService }
    ]
})
export class NewAccessDialogComponent {
    @ViewChild('dynForm') dynForm: DynFormComponent;
    public addNew = false;
    public originalData = {} as EmployeeAccess;
    constructor(
        public dialogRef: MatDialogRef<NewAccessDialogComponent>,
        defaultForm: FormsDataServiceInterface,
        private esearchSettingsService: EsearchSettingsService,
        @Inject(MAT_DIALOG_DATA) public data) {
        (defaultForm as HttpFormsDataService).formServicePath = `/api/es/form/${this.appId}/${this.tabId}`;
        Object.assign(this.originalData, data);
    }

    public appId = 'ats';
    public tabId = 'access';

    close() {
        this.dialogRef.close();
    }

    async onSubmit(event: EmployeeAccess) {
        await this.esearchSettingsService.updateRecordIndexing('ats', 'access', 'EmployeeId', [event.EmployeeId.toString()]);
        if (this.addNew) {
            this.data = {
                EmployeeId: this.originalData.EmployeeId,
                SiteId: this.originalData.SiteId,
                StartDate: this.originalData.StartDate,
                TypeId: null
            };
            this.addNew = false;
        } else {
            this.dialogRef.close(event);
        }
    }

}
